export default __webpack_public_path__ + "static/prem-bg-d7c8ef83a9911fc52800daae19817f03.jpg";